import {
  Directive,
  Output,
  EventEmitter,
  AfterViewInit,
  OnDestroy,
} from '@angular/core';
import { MatAutocomplete } from '@angular/material/autocomplete';
import { Subscription } from 'rxjs';

@Directive({
  selector: '[appMatAutocompleteInfiniteScroll]',
  standalone: true,
})
export class MatAutocompleteInfiniteScrollDirective
  implements AfterViewInit, OnDestroy
{
  @Output() infiniteScroll = new EventEmitter<void>();
  private openedSub: Subscription;
  private panel: HTMLElement;
  private scrollHandler = this.onScroll.bind(this);

  constructor(private matSelect: MatAutocomplete) {}

  ngAfterViewInit() {
    this.openedSub = this.matSelect.opened.subscribe(() => {
      this.attachScroll();
    });
  }

  attachScroll() {
    const tryAttach = () => {
      this.panel = document.body.querySelector('.mdc-menu-surface--open');
      if (this.panel) {
        this.panel.addEventListener('scroll', this.scrollHandler);
      } else {
        setTimeout(tryAttach, 50);
      }
    };
    tryAttach();
  }

  onScroll(event: any) {
    const panel = event.target;

    if (!panel || panel !== this.panel) return;
    if (panel.scrollTop + panel.clientHeight >= panel.scrollHeight - 50) {
      this.infiniteScroll.emit();
    }
  }

  ngOnDestroy() {
    if (this.openedSub) this.openedSub.unsubscribe();
    if (this.panel)
      this.panel.removeEventListener('scroll', this.scrollHandler);
  }
}
